import { FieldRenderProps } from 'react-final-form'
import Upload from '../../control/upload/Upload'

type UploadInputProps = FieldRenderProps<string, any>

const UploadInput: React.FC<UploadInputProps> = ({ input, value, meta, ...rest }) => {
    return <Upload {...input} {...rest} data={input.value.length > 0 ? (input.value as any) : []} />
}

export default UploadInput
